import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAuth, UserRole } from "../context/AuthContext";

interface RequireAuthProps {
  allowedRoles: UserRole[];
  redirectTo?: string;
  children: React.ReactElement;
}

const RequireAuth: React.FC<RequireAuthProps> = ({ allowedRoles, redirectTo, children }) => {
  const { role } = useAuth();
  const location = useLocation();

  if (allowedRoles.includes(role)) {
    return children;
  }

  // Always redirect to /login after logout
  const fallback = redirectTo || "/login";
  return <Navigate to={fallback} state={{ from: location }} replace />;
};

export default RequireAuth;


